import { createContext, useContext } from "react";

type FileOutletScopeContextValue = {
    inFileOutlet: boolean;
};

const FileOutletScopeContext = createContext<FileOutletScopeContextValue>({ inFileOutlet: false });

export const FileOutletScopeProvider = FileOutletScopeContext.Provider;

export const useFileOutletScope = (): FileOutletScopeContextValue => useContext(FileOutletScopeContext);
